import { Filter } from '../../aggregations';

export const defaultFilter = (): Filter => ({ label: '', query: '*' });
